import { render, staticRenderFns } from "./component-items.vue?vue&type=template&id=1460ee20&scoped=true&"
import script from "./component-items.vue?vue&type=script&lang=js&"
export * from "./component-items.vue?vue&type=script&lang=js&"
import style0 from "./component-items.vue?vue&type=style&index=0&id=1460ee20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1460ee20",
  null
  
)

export default component.exports